<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
  <mat-card class="p-0">
    <mat-tab-group>
      <mat-tab label="Detalhes">
        <div fxLayout="row wrap" fxLayout.lt-sm="column">
          <div fxFlex="100" class="pr-1"><br></div>
          <div fxFlex="25" class="pr-1">
            <mat-chip mat-sm-chip [color]="'primary'"> Chave de Acesso: </mat-chip>&nbsp;
          </div>
          <div fxFlex="25" class="pr-1">
            <mat-label> {{this.lcto?.nfechaveacesso}}</mat-label>
          </div>
          <div fxFlex="100" class="pr-1"><br></div>
          <div fxFlex="25" class="pr-1">
            <mat-label>
              <mat-chip mat-sm-chip [color]="'primary'"> Protocolo: </mat-chip>&nbsp;
            </mat-label>&nbsp;
          </div>
          <div fxFlex="25" class="pr-1">
            <mat-label mat-sm-chipcolor="accent"> {{this.lcto?.nfeprotocolo}}</mat-label>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="XML Gerado">
        <pre> {{doctoCForm.controls['nfexml']?.value | xml}}</pre>
      </mat-tab>
      <mat-tab label="XML Distribuiçao">
        <pre> {{doctoCForm.controls['nfexmldistribuicao']?.value | xml}}</pre>
      </mat-tab>
    </mat-tab-group>
  </mat-card>
</div>
<mat-dialog-actions>
  <div fxFlex="100" class="mt-1">
    <span fxFlex></span>
    <button mat-button color="warn" type="button" (click)="close()">{{"CLOSE" | translate }}</button>
  </div>
</mat-dialog-actions>